<template>
  <div
      class="z-30 fixed inset-y-0 left-0 w-64 bg-gray-100 border-r overflow-y-auto sm:static sm:block sm:translate-x-0 sm:transition-none -translate-x-full ease-in transition-medium"
      :class="opened ? '' : 'hidden'"
  >
    <div class="absolute top-0 left-0 pl-4 pt-3 sm:hidden">
      <button
          class="block text-gray-600 hover:text-gray-800 focus:outline-none"
          @click="opened = false"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6">
          <path
              d="M17.293 18.707a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 00-1.414-1.414L12 10.586 6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 101.414 1.414L12 13.414l5.293 5.293z"
          />
        </svg>
      </button>
    </div>
    <nav class="mt-8 sm:mt-0">
      <!-- mobile -->
      <div class="mb-8 p-6 border-b sm:hidden">
        <div class="flex items-center">
          <img
              src="/img/example-logo.svg"
              alt
              class="h-8 w-8 rounded-full object-cover"
          />
          <span class="ml-4 mr-2 text-sm font-medium text-gray-800">{{
              $auth.user().full_name
            }}</span>
        </div>
        <div class="mt-4">
          <router-link
              :to="{ name: 'profile.edit' }"
              class="block text-sm font-medium text-gray-700"
          >Настройки
          </router-link
          >

          <button
              @click="$auth.logout()"
              class="mt-4 block text-sm font-medium text-gray-700 focus:outline-none"
          >
            Выйти
          </button>
        </div>
      </div>

      <!-- mobile -->
      <div class="px-6 sm:hidden" v-if="false">
        <a href="#" class="block py-1 text-sm font-medium text-gray-900"
        >Mailbox</a
        >
        <a
            href="#"
            class="mt-2 block py-1 text-sm font-medium text-gray-900"
        >Customers</a
        >
        <a
            href="#"
            class="mt-2 block py-1 text-sm font-medium text-gray-900"
        >Reporting</a
        >
        <a
            href="#"
            class="mt-2 block py-1 text-sm font-medium text-gray-900"
        >Manage</a
        >
      </div>

      <!-- desktop -->
      <div class="mt-4 px-6">
        <template v-for="link in links">
          <router-link
              active-class="bg-gray-200 active"
              v-if="link.show"
              :key="link.name"
              :to="{ name: link.route.name }"
              class="mb-2 -mx-3 px-3 py-2 flex items-center justify-between text-sm font-medium hover:bg-gray-200 rounded-lg"
          >
                        <span class="inline-flex">
                            <i
                                :class="['text-gray-500', link.icon]"
                                class="h-6 w-6 transition-all ease-out transition-medium"
                                style="font-size: 22px; line-height: 24px"
                            ></i>
                            <span class="ml-3 text-gray-700">{{
                                link.title
                              }}</span>
                        </span>
          </router-link>
        </template>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: 0,
      opened: false,

      links: [
        {
          title: "Dashboard",
          route: {
            name: "admin.dashboard",
          },
          icon: "fas fa-chart-bar",
          show: this.can("access-admin-dashboard"),
        },

        {
          title: "Статистика",
          route: {
            name: "dashboard",
          },
          icon: "fas fa-chart-line",
          show: this.can("access-dashboard"),
        },

        {
          title: "Комиссии",
          route: {
            name: "partner.transactions.index",
          },
          icon: "far fa-chart-bar",
          show: this.can("access-dashboard"),
        },

        {
          title: "Биллинг",
          route: {
            name: "admin.billing",
          },
          icon: "fas fa-cubes",
          show:
              this.can("manage-orders") || this.can("manage-rentals"),
        },

        {
          title: "Школа",
          route: {
            name: "admin.participants.index",
          },
          icon: "far fa-id-card",
          show: this.can("manage-customers"),
        },

        {
          title: "Клиенты",
          route: {
            name: "admin.customers.index",
          },
          icon: "far fa-id-card",
          show: this.can("manage-customers"),
        },

        {
          title: "Абонементы",
          route: {
            name: "admin.subscriptions",
          },
          icon: "fas fa-cubes",
          show:
              this.can("manage-orders") || this.can("manage-rentals"),
        },

        {
          title: "Товары",
          route: {
            name: "admin.products",
          },
          icon: "far fa-clone",
          show: this.can("manage-products"),
        },

        {
          title: "Инструменты продажи",
          route: {
            name: "admin.instruments_sales.index",
          },
          icon: "far fa-clone",
          show: this.can("manage-products"),
        },
        {
          title: "Мои достижения",
          route: {
            name: "admin.achievements.index",
          },
          icon: "far fa-clone",
          show: true
        },

        {
          title: "Настройки",
          route: {
            name: "admin.settings",
          },
          icon: "fas fa-money-check",
          show:
              this.can("manage-assets") ||
              this.can("manage-branches") ||
              this.can("manage-product-categories"),
        },

        {
          title: "Пользователи",
          route: {
            name: "admin.users",
          },
          icon: "far fa-user-circle",
          show: this.can("manage-users"),
        },
      ],
    };
  },

  mounted() {
    let vm = this;

    Bus.$on("open-sidebar", () => {
      vm.opened = true;
    });
  },
};
</script>
